import React from 'react'
import { useTheme } from 'styled-components'

import { IconProps } from '@application/Interfaces/Icons/types'
import { reverseArrowIconDirectionForRtl } from '@application/Interfaces/Icons/utils'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

import { SVG } from './ArrowWithCircle.styled'

export const ArrowWithCircle = ({
    className,
    width = 100,
    height = 100,
    direction = 'right',
    fillColorCode = 'p500',
    strokeColorCode = 'white',
}: IconProps & { fillColorCode?: string; strokeColorCode?: string }): JSX.Element => {
    const theme = useTheme() as Theme
    const fillColor = theme.color[fillColorCode]
    const strokeColor = theme.color[strokeColorCode]

    const directionTransformed = reverseArrowIconDirectionForRtl({
        iconDirection: direction,
        themeDirection: theme.direction,
    })

    return (
        <SVG
            className={className}
            width={width}
            height={height}
            direction={directionTransformed}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="50" cy="50" r="50" fill={fillColor} />
            <path
                d="M57.2938 32.2484C56.2952 31.2505 54.6763 31.2505 53.6777 32.2484C52.6789 33.2464 52.6789 34.8647 53.6777 35.8627L65.7687 47.9444H28.0571C26.6452 47.9444 25.5 49.0882 25.5 50.5C25.5 51.9118 26.6452 53.0556 28.0571 53.0556H65.7687L53.6777 65.1373C52.6789 66.1353 52.6789 67.7536 53.6777 68.7516C54.6763 69.7495 56.2952 69.7495 57.2938 68.7516L73.7509 52.3072C74.7497 51.3092 74.7497 49.6908 73.7509 48.6928L57.2938 32.2484Z"
                fill={strokeColor}
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SVG>
    )
}
